// extracted by css-extract-rspack-plugin
export default {"chartContainer":"src-modules-desktop-components-DevPanel-DevChart-module__chartContainer-vJOKDm","tooltip":"src-modules-desktop-components-DevPanel-DevChart-module__tooltip-DfrDrq","tooltipVal":"src-modules-desktop-components-DevPanel-DevChart-module__tooltipVal-Dqi5vx","tooltipTime":"src-modules-desktop-components-DevPanel-DevChart-module__tooltipTime-zQndaP"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"chartContainer\":\"src-modules-desktop-components-DevPanel-DevChart-module__chartContainer-vJOKDm\",\"tooltip\":\"src-modules-desktop-components-DevPanel-DevChart-module__tooltip-DfrDrq\",\"tooltipVal\":\"src-modules-desktop-components-DevPanel-DevChart-module__tooltipVal-Dqi5vx\",\"tooltipTime\":\"src-modules-desktop-components-DevPanel-DevChart-module__tooltipTime-zQndaP\"}";
        // 1793875575826
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  